import { SubscriptionManager } from '@aibees/shared/features';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import { usePlanDynamicAction } from './hooks/use-plan-dynamic-action';
import * as Styled from './styles';
import type { PlanDynamicActionProps as Props } from './types';
import { getButtonPropsForMode } from './utils/get-button-props-for-mode';

export const PlanDynamicAction = memo(({ className }: Props) => {
  const { actionMode, buttonText } = usePlanDynamicAction();
  const { data } = useCurrentSubscriptionApi();
  const { isMostPopular } = usePlanCardContext();
  const currentPlanIsFree = Boolean(data?.current?.plan?.metadata.is_free);

  const buttonProps = getButtonPropsForMode(
    actionMode,
    currentPlanIsFree,
    isMostPopular
  );

  return (
    <SubscriptionManager
      actionMode={actionMode}
      triggerElement={
        <Styled.Wrapper
          disabled={!actionMode}
          color="inherit"
          size="small"
          fullWidth
          className={className}
          sx={buttonProps.sx}
          {...buttonProps.props}
        >
          {buttonText}
        </Styled.Wrapper>
      }
    />
  );
});

PlanDynamicAction.displayName = 'PlanDynamicAction';
